import { Textarea as BaseTextarea, forwardRef, TextareaProps } from '@bonusly/design-system';

import resizeIcon from '../../assets/images/resize.svg';

export const Textarea = forwardRef(({ ...rest }: TextareaProps, ref) => {
	return (
		<BaseTextarea
			ref={ref}
			fontFamily="ui"
			fontWeight="normal"
			color="text.default"
			backgroundColor="bg.surface"
			borderColor="border.input"
			px={3}
			py={2}
			css={{
				'&::-webkit-resizer': {
					height: 1,
					width: 1,
					backgroundImage: `url(${resizeIcon})`,
					backgroundRepeat: 'no-repeat',
				},
			}}
			_hover={{
				borderColor: 'border.input',
			}}
			_invalid={{
				backgroundColor: 'error.inputBg',
				borderColor: 'error.inputBorder',
			}}
			_focusVisible={{
				borderColor: 'border.focus',
				borderWidth: '2px',
				boxShadow: 'none',
			}}
			_disabled={{
				color: 'text.disabled',
				backgroundColor: 'secondary.bgAlpha',
				borderColor: 'border.default',
				cursor: 'not-allowed',
			}}
			{...rest}
		/>
	);
});
